import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Organization } from "@/types/api"

interface OrganizationState {
  loading: boolean
  organizations: Organization[]
  activeOrganization: Organization | null
}

const initialState: OrganizationState = {
  loading: false,
  organizations: [],
  activeOrganization: null,
}

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganizations: (state, action: PayloadAction<Organization[]>) => {
      state.organizations = action.payload
    },
    setActiveOrganization: (state, action: PayloadAction<Organization>) => {
      state.activeOrganization = action.payload
    },
    updateActiveOrganization: (state, action: PayloadAction<Organization>) => {
      state.activeOrganization = action.payload
      // Also update the organization in the organizations list
      const index = state.organizations.findIndex((org) => org.id === action.payload.id)
      if (index !== -1) {
        state.organizations[index] = action.payload
      }
    },
    clearOrganizations: (state) => {
      state.organizations = []
      state.activeOrganization = null
      state.loading = false
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export const { setOrganizations, setActiveOrganization, updateActiveOrganization, clearOrganizations, setLoading } =
  organizationSlice.actions

export default organizationSlice.reducer
